import { useCallback, useEffect, useState } from 'react';
import { rage, useObservable } from '~/rage';
import {
	INumberPlatePrice,
	ModalButtonColor,
	ModalType,
	WalletType,
} from '~/shared';
import { plateTypeList } from '../components/ChangeTab/ChangeTab.model';
import { useLayoutSelector } from '../redux';
import { isCustomType, validateNumberPlate } from '../utils';

const useBuy = () => {
	const number = useLayoutSelector((state) => state.plateBuying.number);
	const regionCode = useLayoutSelector((state) => state.plateBuying.regionCode);
	const customNumber = useLayoutSelector(
		(state) => state.plateBuying.customNumber,
	);
	const selectedTypeIndex = useLayoutSelector(
		(state) => state.plateBuying.selectedTypeIndex,
	);
	const regionState = useLayoutSelector((state) => state.plateBuying.region);

	const [plateNumberPriceCash, setPlateNumberPriceCash] =
		useState<INumberPlatePrice>();
	const [plateNumberPriceDonate, setPlateNumberPriceDonate] =
		useState<INumberPlatePrice>();
	const modalState = useObservable(rage.modal.getCurrentModal());

	useEffect(() => {
		const selectedType = plateTypeList[selectedTypeIndex];

		if (isCustomType(selectedType.type)) {
			if (customNumber && customNumber.length > 0) {
				rage.vehicleNumberPlates
					.getNumberPlatePrice(
						{
							type: selectedType.type,
							text: customNumber,
							region: '',
						},
						WalletType.Cash,
					)
					.then((value) => value && setPlateNumberPriceCash(value));

				rage.vehicleNumberPlates
					.getNumberPlatePrice(
						{
							type: selectedType.type,
							text: customNumber,
							region: '',
						},
						WalletType.Donate,
					)
					.then((value) => value && setPlateNumberPriceDonate(value));
			}
		} else {
			if (number.length === 6 && number.indexOf(' ') === -1 && regionCode) {
				rage.vehicleNumberPlates
					.getNumberPlatePrice(
						{
							type: selectedType.type,
							text: number,
							region: regionCode,
						},
						WalletType.Cash,
					)
					.then((value) => value && setPlateNumberPriceCash(value));

				rage.vehicleNumberPlates
					.getNumberPlatePrice(
						{
							type: selectedType.type,
							text: number,
							region: regionCode,
						},
						WalletType.Donate,
					)
					.then((value) => value && setPlateNumberPriceDonate(value));
			}
		}
	}, [number, regionCode, customNumber, selectedTypeIndex]);

	const handleBuy = useCallback(
		(wallet: WalletType) => {
			if (modalState) {
				return;
			}

			const selectedType = plateTypeList[selectedTypeIndex];

			const selectedNumber = isCustomType(selectedType.type)
				? customNumber
				: number;
			const selectedRegion = isCustomType(selectedType.type) ? '' : regionCode;
			const price =
				wallet === WalletType.Donate
					? plateNumberPriceDonate?.price
					: plateNumberPriceCash?.price;

			if (!isCustomType(selectedType.type)) {
				if (
					!validateNumberPlate(
						selectedType.type,
						selectedNumber,
						selectedRegion,
					)
				) {
					rage.notifications.showError('Номер не соответствует формату');
					return;
				}

				if (!selectedRegion) {
					rage.notifications.showError('Введите корректный регион');
					return;
				}
			}

			if (!regionState && !isCustomType(selectedType.type)) {
				rage.notifications.showError('Введите корректный регион');
				return;
			}

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: `Вы действительно хотите купить номер ${selectedNumber}${selectedRegion}?`,
					price: price || 0,
					wallet: wallet,
					acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result) => {
					if (result.isAccepted) {
						rage.vehicleNumberPlates.buyNumberPlate(
							{
								type: selectedType.type,
								text: selectedNumber,
								region: selectedRegion,
							},
							wallet,
						);
					}
				},
			);
		},
		[
			plateNumberPriceCash,
			plateNumberPriceDonate,
			number,
			regionCode,
			customNumber,
			selectedTypeIndex,
			regionState,
			validateNumberPlate,
			modalState,
		],
	);

	return { handleBuy, plateNumberPriceCash, plateNumberPriceDonate };
};

export { useBuy };
